import React from 'react';
import {Link, useNavigate} from "react-router-dom";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import {hasPermissionLink} from "@/components/can/Can";
import PermList from "@/lib/helper/PermList";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import {Button} from "antd";
import AdminLayout from "@/components/layout/admin/adminLayout";
import TableSearch from "@/components/table/tableSearch";
import {useApiSearchAdminTakenunit} from "@/api/takenunit";
import {toFaNumberFormat} from "@/lib/utils/number";

function AdminUsersToDelivery(props) {
    const navigate = useNavigate();

    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 70,
        },
        {
            title: 'کد دانش آموز',
            dataIndex: 'student',
            key: 'student_code',
            width: 100,
            render: (studentId, record) => {
                if (record.student_detail?.code) {
                    return record.student_detail.code;
                }
                return studentId || '-';
            }
        },
        {
            title: 'نام دانش آموز',
            dataIndex: 'student_detail',
            key: 'student_name',
            render: (studentDetail) => {
                if (studentDetail) {
                    return `${studentDetail.firstname || ''} ${studentDetail.lastname || ''}`.trim() || '-';
                }
                return '-';
            }
        },
        {
            title: 'شماره موبایل',
            dataIndex: 'student_detail',
            key: 'student_mobile',
            responsive: ['md'],
            render: (studentDetail) => {
                if (studentDetail?.mobile) {
                    return studentDetail.mobile;
                }
                return '-';
            }
        },
        {
            title: 'عنوان درس',
            dataIndex: 'lesson',
            key: 'lesson_title',
            render: (lesson) => {
                if (lesson?.topic?.title) {
                    return lesson.topic.title;
                }
                return '-';
            }
        },
        {
            title: 'کد درس',
            dataIndex: 'lesson',
            key: 'lesson_code',
            responsive: ['lg'],
            render: (lesson) => {
                return lesson?.code || '-';
            }
        },

        {
            title: 'وضعیت ثبت‌نام',
            dataIndex: 'status',
            key: 'enrollment_status',
            width: 120,
            render: (text) => {
                const statusColors = {
                    remove: 'bg-red-100 text-red-800',
                    taken: 'bg-green-100 text-green-800',
                    removeadmin: 'bg-red-100 text-red-800',
                    removeforce: 'bg-red-100 text-red-800',
                    cancel: 'bg-purple-100 text-purple-800',
                    reserve: 'bg-yellow-100 text-yellow-800',


                };
                const statusLabels = {
                    remove: 'حذف شده',
                    taken: 'ثبت‌نام شده',
                    removeadmin: 'حذف مدیر',
                    removeforce: 'حذف اجباری',
                    cancel: 'لغو شده',
                    reserve: 'رزرو',
                };
                return (
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${statusColors[text] || 'bg-gray-100'}`}>
                    {statusLabels[text] || text}
                </span>
                );
            }
        },

        {
            title: 'موجودی فعلی کاربر',
            dataIndex: 'current_budget',
            key: 'current_budget',
            responsive: ['md'],
            render: (text, record) => {
                return <div>{toFaNumberFormat(record?.student_detail?.current_budget)}</div>;
            }
        },

        {
            title: 'تاریخ ثبت',
            dataIndex: 'datecreated',
            key: 'datecreated',
            responsive: ['md'],
            render: (text) => {
                return convertToJalaliWithFormat(text, 'jYYYY/jMM/jDD HH:mm:ss');
            }
        },
        {
            title: 'عملیات',
            dataIndex: 'id',
            key: 'actions',
            width: 120,
            render: (text, record) => {
                return (
                    <div className="flex gap-2">

                        <Link
                            to={hasPermissionLink(PermList.CLASSROOM_LIST, sprintf(URLS.admin.products.edit, {id: record.id}))}
                        >
                            <Button size={'small'} variant={'outlined'} color={'default'}>
                                مشاهده
                            </Button>
                        </Link>
                    </div>
                );
            }
        },
    ];


    return (
        <AdminLayout backTo={URLS.admin.products.dashboard} pageTitle={'لیست کلی افراد'}>

            <TableSearch
                searchInput={true}
                addButton={
                    <div className={'flex justify-end gap-1'}>



                    </div>
                }
                apiFn={useApiSearchAdminTakenunit}
                columns={columns}
                scroll={{x: true}}
                responsive={true}
            />

        </AdminLayout>
    );
}

export default AdminUsersToDelivery;